import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip } from 'reactstrap';
import Button from 'app/components/general/Button';

import { actionConfirmed } from 'app/ducks/loading/actions';

interface IShareLinkProps {
  link: string;
  actions: any;
}
@connect(null, (dispatch) => ({
  actions: bindActionCreators({ actionConfirmed }, dispatch),
}))
export default class ShareLink extends React.Component<IShareLinkProps> {
  static defaultProps: IShareLinkProps = {
    link: undefined,
    actions: undefined,
  };

  state = {
    tooltipOpen: false,
    copied: false,
  };

  toggleTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };

  render(): React.ReactNode {
    return (
      <div className="d-inline-block">
        <CopyToClipboard
          text={this.props.link}
          onCopy={() => {
            this.setState({ copied: true });
            setTimeout(() => {
              this.setState({ copied: false });
            }, 2000);
          }}
        >
          <Button
            id="share-link-input"
            className="btn-thinner btn-2 btn-share with-margin-right margin-bottom-10"
            successText="Link copied"
            hasSaved={this.state.copied}
            noLoading
          >
            Share team link
          </Button>
        </CopyToClipboard>
        <Tooltip
          placement="right"
          isOpen={this.state.tooltipOpen}
          target="share-link-input"
          toggle={this.toggleTooltip}
        >
          Click to copy
        </Tooltip>
      </div>
    );
  }
}
